import { Link } from "react-router-dom";

const upcomingItems = [
  {
    id: 1,
    title: "React for Beginners (Live Workshop)",
    date: "Sat, Feb 10",
    duration: "2 hours",
    mode: "Online",
    level: "Beginner",
    isFree: true,
    highlights: ["Project-based learning", "Q&A session", "Certificate included"],
    imageUrl:
      "https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?auto=format&fit=crop&w=1200&q=80",
    imageAlt: "Laptop with code editor - React workshop",
  },
  {
    id: 2,
    title: "Node.js + Express API Bootcamp",
    date: "Mon, Feb 19",
    duration: "5 days",
    mode: "Online",
    level: "Intermediate",
    isFree: false,
    priceText: "GHS 250",
    highlights: ["REST API design", "Auth & security basics", "MySQL integration"],
    imageUrl:
      "https://images.unsplash.com/photo-1555066931-4365d14bab8c?auto=format&fit=crop&w=1200&q=80",
    imageAlt: "Developer coding backend APIs",
  },
  {
    id: 3,
    title: "Frontend Interview Prep (React)",
    date: "Fri, Mar 1",
    duration: "3 hours",
    mode: "In-person",
    level: "All levels",
    isFree: true,
    highlights: ["Live coding practice", "CV tips", "Mock interview"],
    imageUrl:
      "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1200&q=80",
    imageAlt: "Team interview preparation session",
  },
];

export default function UpcomingEvents() {
  return (
    <>
      <section className="py-5 bg-dark text-light" id="events">
        <div className="container">
          {/* Header */}
          <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3 mb-4">
            <div>
              <h2 className="fw-bold mb-1">Upcoming Events & Courses</h2>
              <p className="text-light opacity-75 mb-0">
                Learn with practical sessions designed to improve your skills fast.
              </p>
            </div>

            <Link to="/events" className="btn btn-outline-light">
              View All
            </Link>
          </div>

          {/* Cards */}
          <div className="row g-4">
            {upcomingItems.map((item) => (
              <div key={item.id} className="col-12 col-lg-4">
                <div className="card text-white h-100 bg-secondary bg-opacity-10 border-0 shadow-sm overflow-hidden">
                  {/* Image section */}
                  <img
                    src={item.imageUrl}
                    alt={item.imageAlt}
                    className="card-img-top"
                    loading="lazy"
                    style={{
                      height: 190,
                      objectFit: "cover",
                      objectPosition: "center",
                    }}
                  />

                  <div className="card-body p-4">
                    {/* Top row */}
                    <div className="d-flex align-items-start justify-content-between gap-3">
                      <h5 className="fw-bold mb-2">{item.title}</h5>
                      <span
                        className={`badge ${
                          item.isFree ? "bg-success" : "bg-warning text-dark"
                        }`}
                      >
                        {item.isFree ? "FREE" : item.priceText || "PAID"}
                      </span>
                    </div>

                    {/* Meta info */}
                    <div className="d-flex flex-wrap gap-3 text-light opacity-75 small mb-3">
                      <div className="d-flex align-items-center gap-2">
                        <i className="bi bi-calendar-event" />
                        <span>{item.date}</span>
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        <i className="bi bi-clock" />
                        <span>{item.duration}</span>
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        <i className="bi bi-broadcast" />
                        <span>{item.mode}</span>
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        <i className="bi bi-bar-chart" />
                        <span>{item.level}</span>
                      </div>
                    </div>

                    {/* Highlights */}
                    <div className="mb-4">
                      <p className="fw-semibold mb-2">Key highlights</p>
                      <ul className="mb-0 ps-3 text-light opacity-75">
                        {item.highlights.map((h, idx) => (
                          <li key={idx}>{h}</li>
                        ))}
                      </ul>
                    </div>

                    {/* CTA */}
                    <div className="d-grid">
                      <Link to="/page/register" className="btn custom-btn">
                        Register Now
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Footer note */}
          <p className="text-light opacity-75 small mt-4 mb-0">
            Slots are limited for some sessions. Register early to secure a spot.
          </p>
        </div>
      </section>

      {/* White divider */}
      <hr className="border-light opacity-25 m-0" />
    </>
  );
}
